// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'

import AMap from 'vue-amap'

import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

Vue.component('datetime', Datetime)

import '@/assets/css/AdminLTE.min.css'
import '@/assets/js/adminlte.min.js'
import '@/assets/css/skins/_all-skins.min.css'
import '@/assets/js/bootstrap-prettyFile.js'
// import '@/assets/js/switchery.js'

import echarts from 'echarts'

Vue.prototype.echarts = echarts

//公共js文件
import globalVariable from '@/assets/js/global_variable.js'

Vue.prototype.global = globalVariable

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap-table/dist/bootstrap-table.min.css'
import 'bootstrap-table/dist/bootstrap-table.min.js'
import 'bootstrap-table/dist/locale/bootstrap-table-zh-CN.min.js'

import 'chosen-js/chosen.jquery.js'
import 'chosen-js/chosen.min.css'

import 'font-awesome/css/font-awesome.min.css'

import axios from 'axios'

Vue.prototype.axios = axios

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js